import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    email: "",
    lastVerifiedEmail: "",
    emailVerificationInFlight: false,
    emailHasBeenVerified: false,
    emailMustBeVerified: true,
    emailExistsInCurrentRegistration: false,
    emailExistsInPreviousRegistration: false,
    scrollToEmailField: false,
    yourFundraisingDashboard: "",
};

export const slice = createSlice({
    name: "emailVerification",
    initialState,
    reducers: {
        // return to a clean state for an email verification process
        resetEmailVerificationState: (state) => ({ state, ...initialState }),
        updateEmail: (state, action) => {
            state.email = action.payload;
        },
        updateLastVerifiedEmail: (state, action) => {
            state.lastVerifiedEmail = action.payload;
        },
        updateEmailVerificationInFlight: (state, action) => {
            state.emailVerificationInFlight = action.payload;
        },
        updateEmailHasBeenVerified: (state, action) => {
            state.emailHasBeenVerified = action.payload;
        },
        updateEmailMustBeVerified: (state, action) => {
            state.emailMustBeVerified = action.payload;
        },
        updateEmailExistsInCurrentRegistration: (state, action) => {
            state.emailExistsInCurrentRegistration = action.payload;
        },
        updateEmailExistsInPreviousRegistration: (state, action) => {
            state.emailExistsInPreviousRegistration = action.payload;
        },
        updateScrollToEmailField: (state, action) => {
            state.scrollToEmailField = action.payload;
        },
        updateYourFundraisingDashboard: (state, action) => {
            state.yourFundraisingDashboard = action.payload;
        },
    },
});

export const {
    resetEmailVerificationState,
    updateEmail,
    updateLastVerifiedEmail,
    updateEmailVerificationInFlight,
    updateEmailHasBeenVerified,
    updateEmailMustBeVerified,
    updateEmailExistsInCurrentRegistration,
    updateEmailExistsInPreviousRegistration,
    updateScrollToEmailField,
    updateYourFundraisingDashboard,
} = slice.actions;

export const selectAllEmailVerification = (state) => state.emailVerification;

export const selectEmail = (state) => state.emailVerification.email;

export const selectLastVerifiedEmail = (state) =>
    state.emailVerification.lastVerifiedEmail;

export const selectEmailVerificationInFlight = (state) =>
    state.emailVerification.emailVerificationInFlight;

export const selectEmailHasBeenVerified = (state) =>
    state.emailVerification.emailHasBeenVerified;

export const selectEmailMustBeVerified = (state) =>
    state.emailVerification.emailMustBeVerified;

export const selectScrollToEmailField = (state) =>
    state.emailVerification.scrollToEmailField;

export const selectYourFundraisingDashboard = (state) =>
    state.emailVerification.yourFundraisingDashboard;

export default slice.reducer;
